import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { useTheme } from '@mui/material/styles'
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline'
import { type ElementType } from 'react'

const resolveIconComponent = (iconSource: unknown): ElementType => {
  if (iconSource && typeof iconSource === 'object' && 'default' in iconSource) {
    return (iconSource as { default: ElementType }).default
  }

  return iconSource as ElementType
}

interface FormFieldErrorMessageProps {
  message: string
  variant?: string
  showIcon?: boolean
}

export const FormFieldErrorMessage = ({
  message,
  variant,
  showIcon = true,
}: FormFieldErrorMessageProps) => {
  const theme = useTheme()
  const ErrorOutlineIconComponent = resolveIconComponent(ErrorOutlineIcon)

  return (
    <Box
      sx={{
        mt: '6px',
        display: 'flex',
        flexDirection: 'row',
        alignContent: 'start',
        alignItems: 'center',
        columnGap: '6px',
        color: '#CC2027',
        backgroundColor:
          variant === 'contained'
            ? ` ${theme.palette.error.main} !important`
            : '',
        borderRadius: '4px',
        height: variant === 'contained' ? '52px' : 'auto',
      }}
    >
      <Box sx={{ paddingLeft: variant === 'contained' ? '2%' : '' }}>
        {showIcon && ErrorOutlineIconComponent ? (
          <ErrorOutlineIconComponent />
        ) : null}
      </Box>

      <Typography
        variant="body-2"
        sx={{
          pt: '2.5px',
          color: variant === 'contained' ? 'rgba(95, 33, 32, 1)' : '',
        }}
      >
        {message}
      </Typography>
    </Box>
  )
}
